import {
  Attivazione,
  Status,
  AttivazioneConsents,
} from './../../../models/attivazione';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgOtpModalComponent } from '../../dialogs/alg-otp-modal/alg-otp-modal.component';
import { ActivatedRoute } from '@angular/router';

import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { takeUntil, withLatestFrom } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { VulnerabilityType } from '../../../models/product';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'alg-attivazioni-step4',
  templateUrl: './alg-attivazioni-step4.component.html',
  styleUrls: ['./alg-attivazioni-step4.component.scss'],
})
export class AlgAttivazioniStep4Component implements OnInit {
  public attivazione: Attivazione;
  public downloadPDFlink = '';
  public isConsentsOk: boolean;
  private consents: AttivazioneConsents;
  private opportunityId: string;
	public idRichiesta: string;
  public urlParams: any;
	public typeRichiesta: string;
  public consentsWithAdditionalProperty: any;
  public linear: boolean;
  public linearGas: boolean;
  public linearLuce: boolean;
  public linearLuceGas: boolean;
  public isOptionGasValue = false;
  public isOptionLightValue = false;
  public isLinearButtonOk: boolean = false;
  public switchStepPrivacy: boolean = false;
  public linearConsents: Object = {};
  public vulnerabilityTypeUserSelected: VulnerabilityType;
  public isProductGasVulnerable: boolean;
  public productName: string;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private api: AlgAttivazioniService,
    private modalDialogService: ModalDialogService,
		private activatedRoute: ActivatedRoute,
    private viewContainer: ViewContainerRef
  ) {
    this.api.vulnerabilityTypeUserSelected$.subscribe((item) => {
      if(item === undefined) {
        this.vulnerabilityTypeUserSelected = null
      } else {
        this.vulnerabilityTypeUserSelected = item;
      }
    })
  }

  ngOnInit() {
		this.activatedRoute.queryParams.subscribe((params) => {
      this.idRichiesta = this.activatedRoute.params['_value'].id;
      this.urlParams = {
        id: this.idRichiesta,
      };
    });
    this.api.attivazione$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((attivazione) => {
        if (!attivazione) {
          return;
        }
        this.attivazione = attivazione;
        this.isProductGasVulnerable = this.attivazione.NewProductName === 'ALG Vulnerabile Gas Domestico' && this.attivazione.vulnerabilityType !== undefined ? true : false;
        this.api.vulnerabilityTypeUserSelected$.next(this.attivazione.vulnerabilityType);
        this.opportunityId = !!attivazione && attivazione.opportunityId;
        this.productName = this.attivazione.NewProductName;
      });

    this.api.isConsentsOk$
      .pipe(
        withLatestFrom(this.api.privacyConsets$, this.api.genericConsets$),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(([isconsentsOk, privacyConsents, genericConsents]) => {
        this.isConsentsOk = isconsentsOk;
        this.consents = {
          ...privacyConsents,
          ...genericConsents,
          notorietaRadio: this.attivazione.notorietaRadio,
        };
      });
      if(this.attivazione.linearGas === true && this.attivazione.linearLuce===true) {
        this.linear = true;
        this.linearLuceGas = true;
        this.linearLuce = true;
        this.linearGas=true;
      };
      if(this.attivazione.linearGas !== true && this.attivazione.linearLuce===true) {
        this.linear = true;
        this.linearLuceGas = false;
        this.linearLuce = true;
        this.linearGas=false;

      };
      if(this.attivazione.linearGas === true && this.attivazione.linearLuce!==true) {
        this.linear = true;
        this.linearLuceGas = false;
        this.linearLuce = false;
        this.linearGas=true;

      };
  };

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

	public setFormatDate(oldDate: string) {
    const arrayDate = oldDate.split('T');
    const tmpHour = arrayDate[1].split('.');
    const tmpDay = arrayDate[0];
    const getHour = tmpHour[0];
    const arrayDay = tmpDay.split('-');
    const day = arrayDay[2];
    const month = arrayDay[1];
    const year = arrayDay[0];

    const newDate = `${day}/${month}/${year} ${getHour}`;

    return newDate;
  };

  // this.linearLuceGas = false;
  // this.linearGas=true;
  // this.linearLuce = false;
  // this.linear = true;

  public gasChecked(bool) {
    this.isOptionGasValue = bool;
    if (this.linearLuceGas===true && this.isOptionGasValue===true && this.isOptionLightValue===true ) {
      this.isLinearButtonOk=true;
    } else if (this.linearLuceGas!==true && this.isOptionGasValue === true) {
      this.isLinearButtonOk=true;
    } else {
      this.isLinearButtonOk=false;
    }
  };

  public luceChecked(bool) {
    this.isOptionLightValue = bool;

    if (this.linearLuceGas===true && this.isOptionGasValue===true && this.isOptionLightValue===true ) {
      this.isLinearButtonOk=true;
    } else if (this.linearLuceGas!==true && this.isOptionLightValue === true) {
      this.isLinearButtonOk=true;
    } else {
      this.isLinearButtonOk=false;
    }
  };

	public openOTPmodal() {



    if ((this.linear && this.isLinearButtonOk) || (!this.linear && this.isConsentsOk)) {
		
      this.consentsWithAdditionalProperty = {
        ...this.consents,
        requestId: `${this.idRichiesta}`,
        requestType: `${this.typeRichiesta}`,
        Alg_OTPCheck__c: this.attivazione['Alg_OTPCheck__c'],
        Alg_OTPCheckDate__c: `${this.attivazione['Alg_OTPCheckDate__c']}`,
        Alg_OTPPhone__c: `${this.attivazione['Alg_OTPPhone__c']}`,
        phone: `${this.attivazione['phone']}`,
        cadastralCondition: true,
        cfgCondition: true,
        cteCondition: true,
        linearGasChecked: `${this.isOptionGasValue}`,
        linearLuceChecked: `${this.isOptionLightValue}`,
        vulnerabilityTypeUserSelected: `${this.vulnerabilityTypeUserSelected}`
      };

      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Un ultimo passo: verifica il tuo numero di cellulare',
        childComponent: AlgOtpModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline textCenter',
        },
        data: {
          isConsentsOk: true,
          consents: this.consentsWithAdditionalProperty,
          phone: `${this.attivazione['phone']}`,
          linear: false,
          consensoType: 'attivazione',
        },
      });
    }
  };


  public nextStep() {
    //if isLinearButton
    if (this.isLinearButtonOk) {
      this.switchStepPrivacy=true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-step4/alg-attivazioni-step4.component.ts